import styled from '@emotion/styled';
import { theme } from '@/layout/GlobalStyles';
import { Link } from 'gatsby';
import { ReactComponent as Arrow } from '../images/svgs/arrow-breadcrumb.svg';

export const AltHeroStyled = styled.section`
    margin-top: 103px;
    margin-bottom: 40px;
    li {
        text-transform: capitalize;
    }
    @media ${theme.device.tablet} {
        margin-bottom: 36px;
    }
    @media ${theme.device.laptop} {
        align-items: center;
        margin-bottom: 72px;
    }
`;

const GreenPanel = styled.div`
    background: ${theme.colors.green1};
    padding: 24px 0;
    h1 {
        text-align: center;
        margin-bottom: 8px;
        font-family: 'Poppins';
        text-transform: uppercase;
    }
    @media ${theme.device.tablet} {
        padding: 32px;
    }
    @media ${theme.device.laptop} {
        height: 374px;
        display: flex;
        flex-direction: column;
        align-items: start;
        justify-content: center;
        .breadcrumb-container {
            display: flex;
            flex-direction: column;
        }
        h1 {
            line-height: 70px;
            font-size: 48px;
            margin-bottom: 24px;
        }
    }
`;

const BreadCrumbs = styled.ul`
    list-style: none;
    display: flex;
    margin-bottom: 8px;
    flex-wrap: wrap;
    line-height: 22.4px;
    margin: 0 auto;
    li {
        flex-shrink: 0;
        gap: 8px;
        display: flex;
        align-items: center;
        svg {
            margin-right: 8px;
        }
    }
    a {
        color: ${theme.colors.gray4};
    }
    .last-link {
        font-weight: 700;
        color: ${theme.colors.green3};
    }
    @media ${theme.device.laptop} {
        flex-wrap: wrap;
        margin-bottom: 24px;
    }
`;

export const AltHero: React.FC<{
    title: string;
    slug: string;
}> = props => {
    const { title, slug } = props;

    return (
        <AltHeroStyled>
            <GreenPanel>
                <div className="breadcrumb-container container">
                    <BreadCrumbs>
                        <li>
                            <Link to="/">Home</Link>
                            <Arrow />
                        </li>

                        <li>
                            <Link to={`/blog/`}>Blog</Link>
                            <Arrow />
                        </li>

                        <li>
                            <Link className="last-link" to={`${slug}`}>
                                {title}
                            </Link>
                        </li>
                    </BreadCrumbs>
                    <h1>{`${title}`}</h1>
                </div>
            </GreenPanel>
        </AltHeroStyled>
    );
};
